import React from "react";
import { ButtonLargeWeb } from "../../../../../components/ButtonLargeWeb";
import { DefaultTrueFocus } from "../../../../../components/DefaultTrueFocus";
import { NavigationButton } from "../../../../../components/NavigationButton";
import { useLocation, useNavigate } from "react-router-dom";

import { StepperInglesLargo } from "../../../../../components/StepperInglesLargo";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const CorporativoBusinessBankingMailWeb = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/business_banking-mail_code-corporativo-web${currentParams}`);
  };

  const laptop = {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#333",
    borderRadius: "15px 15px 5px 5px",
    padding: "17px",
    width: "1400px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const screen = {
    backgroundColor: "white",
    borderRadius: "5px",
    overflowY: "scroll",
    overflowX: "hidden",
    width: "100%",
    height: "800px",
  };

  const container = {
    display: "flex",
    height: "100vh",
  };

  const base = {
    position: "absolute",
    width: "1600px",
    height: "20px",
    backgroundColor: "rgb(170, 170, 170)",
    borderRadius: "0px 0px 10px 10px",
    bottom: 0,
  };

  return (
    <div style={laptop}>
      <div style={screen}>
        <div style={container}>
          <div className="corporativo-business-mail">
            <div className="div-2">
              <div className="frame-wrapper">
                <div className="frame-2">
                  <div className="group-wrapper">
                    <div className="div-wrapper-mail-banking">
                      <div className="group-2">
                        <DefaultTrueFocus
                          className="inputs-text"
                          divClassName="default-true-focus-false-error-false-mensaje-false-success-false-round-corner-false-deshabilitado-false-bigger-placeholder-false-icon-rigth-false-activo-false-icon-left-false-input-sinborde-false"
                          text="Email"
                          text1="user@company.com"
                        />
                        <div className="frame-3">
                          <div className="text-wrapper-2">
                            What is your Email?
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="frame-4">
                    <div className="text-2">Continue later</div>
                    <div onClick={handleButtonClick}>
                      <ButtonLargeWeb
                        className="button-large-WEB-instance"
                        iconLeft={false}
                        iconRigth={false}
                        primarioActive
                        primarioInactive={false}
                        secundarioActive={false}
                        secundarioInactive={false}
                        terciarioActive={false}
                        terciarioInactive={false}
                        text="Continue"
                        textClassName="button-large-WEB-2"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="group-3">
                <div className="frame-5">
                  © 2025 All rights reserved
                  <img width={100} height="auto" src="/img/veritran.svg" />
                  Innovation Lab
                </div>
              </div>

              <div className="frame-6">
                <div className="frame-7">
                  <NavigationButton
                    className="nav-button-left"
                    defaultMasterButtonNavDivClassName="navigation-button-instance"
                    focus={false}
                    platform="web-react"
                    state="default"
                    theme="light"
                    type="back"
                  />
                  <div className="text-wrapper-3">
                    Account opening application
                  </div>
                </div>

                <div className="group-4">
                  <div className="group-5">
                    <div className="group-6">
                      <div className="stepper-ingles-largo-wrapper">
                        <StepperInglesLargo
                          className="stepper-ingles-largo-instance"
                          prendidoHasta={2}
                          prendido="two"
                          property2="two"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="component-7">
                {colors.url_logo !== "" && (
                  <img width={30} height="auto" src={colors.url_logo} />
                )}
                <div className="language">
                  <img
                    src="https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us"
                    height={30}
                    width={30}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={base}></div>
    </div>
  );
};
